/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Addtoshortlist3Inputs */

const en_coinvestments_error_addtoshortlist3 = /** @type {(inputs: Coinvestments_Error_Addtoshortlist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to add organisations to shortlist`)
};

/**
* | output |
* | --- |
* | "Failed to add organisations to shortlist" |
*
* @param {Coinvestments_Error_Addtoshortlist3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_addtoshortlist3 = /** @type {((inputs?: Coinvestments_Error_Addtoshortlist3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Addtoshortlist3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_addtoshortlist3(inputs)
});
export { coinvestments_error_addtoshortlist3 as "coInvestments_error_addToShortlist" }